module.exports = __webpack_public_path__ + "img/right_md_5.85ba9ed2.jpg";